<template>
  <ul class="grid gap-8">
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
    <li
      v-for="article in props.articles"
      :key="article.id"
      class="cursor-pointer"
      @click="navigateToArticle(article)"
    >
      <ArticlePreview :article />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import type { Article } from '~/scopes/campaign/data/articles/data'

import ArticlePreview from './ArticlePreview.vue'

// No `impact` prop: a story's path is built from the story, not from the list you clicked.
const props = defineProps<{ articles: Article[] }>()

const { navigateToArticle } = useModalState()
</script>
